module.exports = __webpack_public_path__ + "img/text-mark4.c10361bb.png";